// frontend/src/admin/teachermanagement.js
import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const TeacherManagement = ({ onBack }) => {
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [formData, setFormData] = useState({ name: '', email: '', password: '' });

    useEffect(() => {
        loadTeachers();
    }, []);

    const loadTeachers = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/teachers/`);
            const data = await res.json();
            setTeachers(data);
        } catch (err) {
            setError('Failed to load teachers');
        } finally {
            setLoading(false);
        }
    };

    const handleCreate = async () => {
        if (!formData.name || !formData.email || !formData.password) {
            setError('All fields are required');
            return;
        }
        setError(null);
        try {
            const res = await fetch(`${API_BASE}/teachers/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            if (!res.ok) {
                const errData = await res.json();
                setError(errData.detail || 'Failed to create teacher');
                return;
            }
            setFormData({ name: '', email: '', password: '' });
            setShowForm(false);
            loadTeachers();
        } catch (err) {
            setError('Failed to create teacher');
        }
    };

    const toggleStatus = async (teacherId, currentStatus) => {
        try {
            await fetch(`${API_BASE}/teachers/${teacherId}/status?is_active=${!currentStatus}`, {
                method: 'PUT'
            });
            loadTeachers();
        } catch (err) {
            setError('Failed to update status');
        }
    };

    return (
        <div className="teacher-management">
            <div className="tm-header">
                <button onClick={onBack} className="tm-back-btn">&larr; Back</button>
                <h2>Teacher Management</h2>
            </div>

            {error && <div className="tm-error">{error}</div>}

            <button className="tm-add-btn" onClick={() => setShowForm(!showForm)}>
                {showForm ? 'Cancel' : '+ Add Teacher'}
            </button>

            {showForm && (
                <div className="tm-form">
                    <input
                        type="text"
                        placeholder="Name"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    />
                    <input
                        type="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    />
                    <button onClick={handleCreate}>Create Teacher</button>
                </div>
            )}

            {loading ? (
                <p>Loading...</p>
            ) : (
                <table className="tm-table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {teachers.map(t => (
                            <tr key={t.teacher_id}>
                                <td>{t.name}</td>
                                <td>{t.email}</td>
                                <td>{t.is_active ? 'Active' : 'Inactive'}</td>
                                <td>
                                    <button onClick={() => toggleStatus(t.teacher_id, t.is_active)}>
                                        {t.is_active ? 'Deactivate' : 'Activate'}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default TeacherManagement;